<template>
  <div>
    <b-tabs
      pills
      justified
    >
      <b-tab>
        <template #title>
          <div class="d-flex align-items-center justify-content-center">
            <FeatherIcon icon="HomeIcon" />
            Mülk Bilgisi
          </div>
        </template>
        <b-card>
          <b-row>
            <b-col cols="12">
              <estate-code />
            </b-col>
            <b-col cols="12">
              <title-name />
            </b-col>
            <b-col cols="12">
              <address-text />
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <city-select />
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <district-select />
            </b-col>
            <b-col cols="12">
              <notes-text />
            </b-col>
            <b-col cols="12">
              <status-select />
            </b-col>
          </b-row>
        </b-card>
        <tenant-view-card v-if="dataItem.tenants.id" />
        <b-card
          v-else
          title="Yeni Kiracı"
        >
          <b-row>
            <b-col cols="12">
              <tenant-select />
            </b-col>
            <b-col
              v-if="estateTenants.id_tenants"
              cols="12"
              md="6"
            >
              <tenant-start />
            </b-col>
            <b-col
              v-if="estateTenants.id_tenants"
              cols="12"
              md="6"
            >
              <tenant-amount />
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab :disabled="!dataItem.id">
        <template #title>
          <div class="d-flex align-items-center justify-content-center">
            <FeatherIcon icon="BookIcon" />
            Evraklar
          </div>
        </template>
        <document-card />
      </b-tab>
      <b-tab :disabled="!dataItem.id">
        <template #title>
          <div class="d-flex align-items-center justify-content-center">
            <FeatherIcon icon="UsersIcon" />
            Kiracı Bilgisi
          </div>
        </template>
        <tenant-card />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTabs, BTab,
} from 'bootstrap-vue'
import EstateCode from '@/views/Admin/Estates/elements/EstateCode.vue'
import TitleName from '@/views/Admin/Estates/elements/Title.vue'
import AddressText from '@/views/Admin/Estates/elements/Address.vue'
import CitySelect from '@/views/Admin/Estates/elements/City.vue'
import DistrictSelect from '@/views/Admin/Estates/elements/District.vue'
import NotesText from '@/views/Admin/Estates/elements/Notes.vue'
import StatusSelect from '@/views/Admin/Estates/elements/StatusSelect.vue'
import TenantSelect from '@/views/Admin/Estates/elements/TenantSelect.vue'
import TenantCard from '@/views/Admin/Estates/elements/TenantCard.vue'
import TenantAmount from '@/views/Admin/Estates/elements/TenantAmount.vue'
import TenantStart from '@/views/Admin/Estates/elements/TenantStart.vue'
import DocumentCard from '@/views/Admin/Estates/elements/DocumentCard.vue'
import TenantViewCard from '@/views/Admin/Estates/elements/TenantViewCard.vue'

export default {
  name: 'ItemForm',
  components: {
    BRow,
    BCol,
    BCard,
    BTabs,
    BTab,
    EstateCode,
    TitleName,
    AddressText,
    CitySelect,
    DistrictSelect,
    NotesText,
    StatusSelect,
    TenantCard,
    TenantSelect,
    TenantAmount,
    TenantStart,
    DocumentCard,
    TenantViewCard,
  },
  computed: {
    dataItem() {
      return this.$store.getters['estates/dataItem']
    },
    estateTenants() {
      return this.$store.getters['estateTenants/dataItem']
    },
  },
}
</script>
